import { getActiveZones } from "./index23.js";
import { getActiveBuildings } from "./index24.js";
import { AddMusclesToAnatomy } from "./index31.js";
import { getDynamicDataset } from "./index32.js";
const pipeAddMuscles = ([parent, { buildingIds, aggProps }]) => {
	const zones = getActiveZones(parent, aggProps);
	for (const zone of zones) {
		const dynamicDataset = getDynamicDataset(aggProps, zone);
		const buildings = getActiveBuildings(zone, aggProps);
		for (const building of buildings) {
			if (buildingIds && !buildingIds.includes(building.uuid)) continue;
			AddMusclesToAnatomy(building.data.anatomy, dynamicDataset.aggConfig);
		}
	}
	return [parent, void 0];
};
export { pipeAddMuscles };

//# sourceMappingURL=index33.js.map